<template>
    <div class="component-group-list gap-lg flex w-full flex-col">
        <p class="max-w-4xl text-sm text-gray-300">
            This preview renders Jira wiki syntax only. It does not convert Markdown or raw HTML.
        </p>
        <div class="flex w-full max-w-4xl flex-col gap-lg xl:flex-row">
            <label class="flex min-w-0 flex-1 flex-col gap-sm">
                <span class="font-semibold">Input</span>
                <textarea
                    v-model="jiraWikiPreviewInput"
                    class="min-h-[22rem] w-full rounded-sm border border-gray-100 bg-white p-md font-mono text-sm leading-6"
                ></textarea>
            </label>
            <div class="flex min-w-0 flex-1 flex-col gap-sm">
                <span class="font-semibold">Preview</span>
                <div class="min-h-[22rem] rounded-sm border border-gray-100 bg-white p-lg">
                    <!-- eslint-disable vue/no-v-html -->
                    <div
                        v-if="jiraWikiPreview.renderAsHtml"
                        class="comment-body"
                        v-html="jiraWikiPreview.text"
                    ></div>
                    <!-- eslint-enable vue/no-v-html -->
                    <p v-else class="comment-body whitespace-pre-wrap">
                        {{ jiraWikiPreview.text }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { resolveIncidentRichText } from '@/lib/incident-rich-text';

const jiraWikiPreviewInput = ref(`h2. Jira Wiki Preview

This supports *bold*, _italic_, -strike-, and [links|https://example.com].

* First item
** Nested item
* -Checked task-

{code:json}
{
  "serviceDeskId": 74,
  "requestTypeId": 605
}
{code}

{color:#36b37e}Status looks good{color}

||Field||Value||
|Region|IS|
|Environment|Playground|`);

const jiraWikiPreview = computed(() => resolveIncidentRichText(jiraWikiPreviewInput.value));
</script>
